import { Platform } from 'react-native';
import { type UpdateFetchResult } from 'expo-updates';
import type { GuardArgs } from 'xstate5/dist/declarations/src/guards';

import type { Context } from './ota-machine.context';
import type { Event } from './ota-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Determines whether updates should be enabled based on the current
 * development mode and platform.
 */
const checkIfUpdatesEnabled: Guard = () => {
  const isUsingDevMode = __DEV__;
  const isWebPlatform = Platform.OS === 'web';

  return !isUsingDevMode && !isWebPlatform;
};

/**
 * A guard that checks if a new update is NOT available based on the update result.
 */
const checkIfNewUpdateIsNotAvailable: Guard<{
  updateResult: UpdateFetchResult | undefined;
}> = (_args, params) => {
  return !params.updateResult?.isNew;
};

/**
 * An external guard that checks if the application is ready to install an
 * OTA update (e.g., app is in the foreground, etc.).
 */
const checkIfAppIsReady: Guard = () => {
  return true;
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfUpdatesEnabled,
  checkIfNewUpdateIsNotAvailable,
  checkIfAppIsReady,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard<Params = void> = (
  args: GuardArgs<Context, Event>,
  params: Params,
) => boolean;
